module.exports = __webpack_public_path__ + "img/abnormalIcon.7c2be992.png";